/**
 * Calculate reading time from HTML content
 * @param {string} htmlContent - HTML content string
 * @returns {number} Reading time in minutes
 */
export function getReadingTime(htmlContent: string | null | undefined): number {
  if (!htmlContent) return 0;

  // Check if we're in a browser environment
  if (typeof document === 'undefined') {
    // Fallback for SSR/Node environments - use regex to strip HTML tags
    const textContent = htmlContent.replace(/<[^>]*>/g, '');
    const wordCount = textContent.trim().split(/\s+/).filter(Boolean).length;
    const readingTime = Math.ceil(wordCount / 200);
    return readingTime;
  }

  // Browser environment - use DOM manipulation for better accuracy
  const div = document.createElement("div");
  div.innerHTML = htmlContent;
  const text = div.textContent || div.innerText || "";

  // Count the words
  const wordCount = text.trim().split(/\s+/).filter(Boolean).length;

  // Standard reading speed = 200 words/min
  const readingTime = Math.ceil(wordCount / 200);

  return readingTime;
}







